module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "添加老师"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "tchForm",
    staticClass: "form",
    attrs: {
      "label-width": 80,
      "model": _vm.tchParam,
      "rules": _vm.ruleTch
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "名字",
      "prop": "firstName"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.tchParam.firstName),
      callback: function($$v) {
        _vm.$set(_vm.tchParam, "firstName", $$v)
      },
      expression: "tchParam.firstName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "姓氏",
      "prop": "lastName"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.tchParam.lastName),
      callback: function($$v) {
        _vm.$set(_vm.tchParam, "lastName", $$v)
      },
      expression: "tchParam.lastName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": " 区号/地域 ",
      "prop": "areaNum"
    }
  }, [_c('phone-area-select', {
    on: {
      "on-change": _vm.onAreaNumChange
    },
    model: {
      value: (_vm.tchParam.areaNum),
      callback: function($$v) {
        _vm.$set(_vm.tchParam, "areaNum", $$v)
      },
      expression: "tchParam.areaNum"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "手机",
      "prop": "account"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.tchParam.account),
      callback: function($$v) {
        _vm.$set(_vm.tchParam, "account", $$v)
      },
      expression: "tchParam.account"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "密码",
      "prop": "password"
    }
  }, [_c('Input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.tchParam.password),
      callback: function($$v) {
        _vm.$set(_vm.tchParam, "password", $$v)
      },
      expression: "tchParam.password"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "国家",
      "prop": "country"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "transfer": ""
    },
    model: {
      value: (_vm.tchParam.country),
      callback: function($$v) {
        _vm.$set(_vm.tchParam, "country", $$v)
      },
      expression: "tchParam.country"
    }
  }, _vm._l((_vm.countryList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.cn))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "性别",
      "prop": "sex"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "transfer": ""
    },
    model: {
      value: (_vm.tchParam.sex),
      callback: function($$v) {
        _vm.$set(_vm.tchParam, "sex", _vm._n($$v))
      },
      expression: "tchParam.sex"
    }
  }, _vm._l((_vm.$constant.sex), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "星级",
      "prop": "star"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.tchParam.star),
      callback: function($$v) {
        _vm.$set(_vm.tchParam, "star", $$v)
      },
      expression: "tchParam.star"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "上课权限",
      "prop": "type"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.tchParam.type),
      callback: function($$v) {
        _vm.$set(_vm.tchParam, "type", _vm._n($$v))
      },
      expression: "tchParam.type"
    }
  }, _vm._l((_vm.$constant.teacherType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态",
      "prop": "status"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.tchParam.status),
      callback: function($$v) {
        _vm.$set(_vm.tchParam, "status", _vm._n($$v))
      },
      expression: "tchParam.status"
    }
  }, _vm._l((_vm.$constant.teacherStatus), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "类型",
      "prop": "category"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.tchParam.category),
      callback: function($$v) {
        _vm.$set(_vm.tchParam, "category", _vm._n($$v))
      },
      expression: "tchParam.category"
    }
  }, _vm._l((_vm.$constant.teacherCategory.filter(function(c) {
    return c.code !== 6
  })), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "授课类型",
      "prop": "tchType"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.tchParam.tchType),
      callback: function($$v) {
        _vm.$set(_vm.tchParam, "tchType", _vm._n($$v))
      },
      expression: "tchParam.tchType"
    }
  }, _vm._l((_vm.$constant.tchType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "是否有试听课权限",
      "prop": "isAudition"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.tchParam.isAudition),
      callback: function($$v) {
        _vm.$set(_vm.tchParam, "isAudition", $$v)
      },
      expression: "tchParam.isAudition"
    }
  }, _vm._l((_vm.$constant.yn), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "时薪",
      "prop": "salary"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.tchParam.salary),
      callback: function($$v) {
        _vm.$set(_vm.tchParam, "salary", _vm._n($$v))
      },
      expression: "tchParam.salary"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingInsertTch
    },
    on: {
      "click": _vm.insert
    }
  }, [_vm._v("添加")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-96b6472a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/teacher/TchInsertModal.vue
// module id = 1924
// module chunks = 8